import { render, staticRenderFns } from "./password-restore.vue?vue&type=template&id=06951aaa&scoped=true&"
import script from "./password-restore.vue?vue&type=script&lang=js&"
export * from "./password-restore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06951aaa",
  null
  
)

export default component.exports